module.exports = __webpack_public_path__ + "img/selected0-min.eec61da9.png";